export default __webpack_public_path__ + "static/media/profileimg.884617ec.jpeg";